import { useTranslation } from 'next-i18next'
import React, { useEffect } from 'react'
import { Head } from '../../component'
import { Button } from '@afterpaytouch/core'

import { TrackPageViewed } from '../../integrations/monitoring'
import { CheckoutPage, BespokeIntegrationType } from '../../model'
import { useAppRouter, useIntegrationNextRoute, useIsAppleRetail } from '../../state'
import { Route } from '../../config/router'

export const EducationIntroPage: CheckoutPage = () => {
  const { t } = useTranslation()
  const router = useAppRouter()

  const pageTitle = `${t('common:brandName')}`
  const appleRetailType = useIsAppleRetail()
  const nextRoute = useIntegrationNextRoute()

  const handleContinue = () => {
    router.replace(nextRoute)
  }

  useEffect(() => {
    if (appleRetailType == null) {
      router.replace(nextRoute ?? Route.ENTER_EMAIL)
    }
  }, [])

  if (appleRetailType == null) {
    return null
  }

  return (
    <>
      <Head title={pageTitle} />
      {t('educationIntro:title')}
      {appleRetailType === BespokeIntegrationType.APPLE_RETAIL_ONLINE && <div>Online</div>}
      {appleRetailType === BespokeIntegrationType.APPLE_RETAIL_INSTORE && <div>Instore</div>}
      <Button onClick={handleContinue}>Continue</Button>
      <TrackPageViewed />
    </>
  )
}
